import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import t from './ProductCostingType.type';
import * as productCostingService from '../../../../services/product-costing.service';
import * as costingTemplateService from '../../../../services/costing-template.service';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const bomProductTesting = (params) => async (dispatch) => {
  try {
    const res = await productCostingService.getBomForProductTesting(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_TESTING_BOM_LIST,
        payload: res.data,
      });
      return res.data;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPermission = (params) => async (dispatch) => {
  try {
    const res = await productCostingService.getcompletionDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.MAEK_AS_COMPLETE,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addPermissions = (id, data, transactionMsg) => async () => {
  try {
    const res = await productCostingService.postPermissions(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addProductCostingData = (params, transactionMsg) => async () => {
  try {
    const res = await productCostingService.addProductCostingDataService(params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(`CONFIRMATION_POPUP_VIEW.PRODUCT_COSTING.${res?.message}`), 'success');
      return res.data.doc;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(transactionMsg(res?.data?.errMsg.toString()), 'danger');
      return false;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductCostingList = (params) => async (dispatch) => {
  try {
    const res = await productCostingService.getProductCostingListService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.LIST_PRODUCT_COSTING,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          searchText: params.searchText,
          isScrolled: params.isScrolled,
        },
      });
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg?.toString(), 'danger');
      return false;
    }
    if (res.code === 401 && res?.data?.errMsg) {
      return false;
    }
    return false;
  } catch (err) {
    console.log(err?.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const deleteProductCosting = (deleteId, devOrderId, transactionMsg) => async (dispatch) => {
  try {
    const body = { productIds: deleteId, devOrderId };
    const res = await productCostingService.deleteProductCostingService(body);
    if (res?.code === 200) {
      await dispatch({
        type: t.REMOVE_PRODUCT_COSTING,
        payload: deleteId,
      });
      toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.DELETED_SUCCESSFULLY'), 'success');
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const getProductCostingDetailsById = (id) => async (dispatch) => {
  try {
    const res = await productCostingService.getProductCostingDetailByIdService(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PRODUCT_COSTING_DETAIL_BY_ID,
        payload: res.data,
      });
      return res?.data;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return res.code;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const updateProductCostingData = (data, transactionMsg) => async () => {
  try {
    const res = await productCostingService.updateProductCostingDataService(data);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.UPDATED_SUCCESSFULLY'), 'success');
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(transactionMsg(`${res?.data?.errMsg}`), 'danger');
      return false;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unMount = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.PRODUCT_COSTING_UNMOUNT,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const copyProductCostingDoc = (id, devOrderId, transactionMsg) => async (dispatch) => {
  try {
    const res = await productCostingService.copyProductCostingDocService(id);
    if (res?.code === 200) {
      const params = {
        pageIndex: 1,
        pageSize: 20,
        devOrderId,
      };
      await dispatch(getProductCostingList(params));
      toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.COPIED_DOCS_SUCCESS'), 'success');
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const inviteSupplierAction = (data, transactionMsg) => async () => {
  try {
    const res = await productCostingService.inviteSupplierService(data);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.INVITED_SUCCESSFULLY'), 'success');
      return res.data.data;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return res.code;
    }
    return res?.data;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setPreviousProductCostingData = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.DUPLICATE_PRODUCT_COSTING_DETAIL,
      payload: data,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const selectAllProduct = (ids) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SELECT_ALL_PRODUCT,
      payload: ids,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearAllProductCostingSuggestedHighlights = (id, keys) => async (dispatch) => {
  try {
    const res = await productCostingService.clearAllProductCostingSuggestedHighlightsService(id, keys);
    if (res?.code === 200) {
      await dispatch(getProductCostingDetailsById(id));
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return res.code;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const addComment = (data, renderList, transactionMsg) => async (dispatch) => {
  try {
    const res = await productCostingService.addCommentService(data);
    if (res?.code === 200) {
      toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.COMMENT_ADDED'), 'success');

      if (renderList) {
        await dispatch(fetchProductCostingComments(data.costingId));
      }
      return res.code;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductCostingComments = (costingId) => async (dispatch) => {
  try {
    const res = await productCostingService.fetchProductCostingCommentsService(costingId);
    if (res?.code === 200) {
      await dispatch({
        type: t.LIST_PRODUCT_COSTING_COMMENT,
        payload: res.data.doc,
      });
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const editCommentAction = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_DATA_TO_UPDATE_COMMENT,
      payload: data,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateComment = (data, transactionMsg) => async (dispatch) => {
  try {
    const res = await productCostingService.updateProductCostingCommentService(data);
    if (res?.code === 200) {
      dispatch(fetchProductCostingComments(data.costingId));
      toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.COMMENT_UPDATED'), 'success');
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductColourways = (id) => async (dispatch) => {
  try {
    const res = await productCostingService.fetchProductColourwaysService(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PRODUCT_COLOUR,
        payload: res?.data,
      });

      return res.data;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductLengths = (id) => async (dispatch) => {
  try {
    const res = await productCostingService.fetchProductLengthsService(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PRODUCT_LENGTHS,
        payload: res?.data,
      });

      return res?.data;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductSizes = (id) => async (dispatch) => {
  try {
    const res = await productCostingService.fetchProductSizesService(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PRODUCT_SIZES,
        payload: res?.data,
      });
      return res?.data;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getUnIntegratedSupplierColouways = (obj) => async (dispatch) => {
  try {
    const res = await productCostingService.getUnIntegratedSupplierColouways(obj);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_UNINTEGRATED_COLOURWAYS,
        payload: res?.data,
      });
    } else if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getUnIntegratedSupplierUnits = (id) => async (dispatch) => {
  try {
    const res = await productCostingService.getUnIntegratedSupplierUnits(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_UNINTEGRATED_UNITS,
        payload: res?.data,
      });
    } else if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getUnIntegratedSupplierCostingDetailsById = (obj) => async (dispatch) => {
  try {
    const res = await productCostingService.getUnIntegratedSupplierCostingDetailsById(obj);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_UNINTEGRATED_PRODUCT_COSTING_DETAILS,
        payload: res.data,
      });
      return res?.data;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
    if (res.code === 400 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return res.code;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const clearedAllStatus = (value) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_CLEARED_HIGHLIGHTS_STATUS,
      payload: value,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const refreshModule = (value) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_REFRESHED_STATE,
      payload: value,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchSupplierDetails = (supplierId) => async (dispatch) => {
  try {
    return await productCostingService.fetchSupplierDetailsService(supplierId);
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchExchangeRateArr = (obj) => async (dispatch) => {
  try {
    const res = await productCostingService.fetchExchangeRateArrService(obj);

    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PRODUCT_COSTING_EXCHANGE_RATE,
        payload: res?.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateCurrencyinSupplierOverview = (obj) => async (dispatch) => {
  try {
    const res = await productCostingService.updateCurrencyinSupplierOverviewService(obj);
    if (res?.code === 200) toasterMsg('supplier currency updated', 'success');
    return res?.code === 200;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setDefaultProductAction = (id, devOrderId, transactionMsg) => async (dispatch) => {
  try {
    const res = await productCostingService.setDefaultProductService(id, devOrderId);
    if (res?.code === 200) {
      const params = {
        pageIndex: 1,
        pageSize: 20,
        devOrderId,
      };
      await dispatch(getProductCostingList(params));
      toasterMsg(transactionMsg('DEVLOPMENT_ORDER.PRODUCT_COSTING.DEFAULT_ADDED'), 'success');
      return true;
    }
    if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const getProductCostingTemplateDetailsByIds = (id, devOrderId) => async (dispatch) => {
  try {
    const res = await costingTemplateService.getCostingTemplateDeatailByIdsService(id, devOrderId);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PRODUCT_COSTING_TEMPLATE_DETAIL_BY_ID,
        payload: res.data,
      });
      return res.data;
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const getUnIntegratedSupplierCostingStage = (obj) => async (dispatch) => {
  try {
    const res = await productCostingService.getUnIntegratedSupplierCostingStage(obj);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_UNINTEGRATED_COSTINGSTAGE,
        payload: res?.data,
      });
    } else if (res.code === 500 && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
      return false;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
